import getNamedTag from '@lib/get-named-tag'
import toTitleCase from '@lib/to-title-case'
import { getStoreFrontUrl } from '@lib/helpers/general'
import dayjs from 'dayjs'
import type { Product } from '../types/Product'

export default function generateProductSchema(
  product: Product.Product,
  variant: Product.ProductVariant
): { [key: string]: any } | null {
  if (!variant) {
    return null
  }
  const brandTag =
    getNamedTag(product.tags as string[], 'Brand')?.replace('_', ' ') ??
    'Hoskings Jewellers'

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: product.name,
    image: product?.images[0]?.url,
    description: product.description,
    sku: variant.sku,
    brand: {
      '@type': 'Brand',
      name: toTitleCase(brandTag),
    },
    offers: {
      '@type': 'Offer',
      url: `${getStoreFrontUrl()}/products${product.path}`,
      priceCurrency: 'AUD',
      price: variant.price.toFixed(2),
      priceValidUntil: dayjs().add(4, 'days').format('YYYY-MM-DD'),
      itemCondition: 'https://schema.org/NewCondition',
      availability: variant.quantityAvailable
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock',
    },
  }
}
